<template>
  <div>
    <router-link :to="{ path: 'prompt-libraries', query: {action: 'create' }}" v-if="sitimmoUser.personnalisationPrompts">
      <el-button type="primary" class="mr-2">{{$t('prompt.linkpromptLibraries')}}</el-button>
    </router-link>
    <router-link :to="{ name: 'post-editorial-modeles' }">
      <el-button type="success" class="mr-2">{{$t('socialPosts.models.title')}}</el-button>
    </router-link>
    <router-link :to="{ name: 'new-social-post' }">
      <el-button type="warning">{{$t('posts.list.createPost')}}</el-button>
    </router-link>
  </div>
</template>

<script>

import ElButton from '../../../components/Button'

export default {
  name: 'SocialPostsListHeader',
  components: { ElButton },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  }
}

</script>

<style scoped>

</style>
